<div class="eb-checkout-buttons">
  <button
    class="eb-checkout-buttons__back-button"
    [disabled]="!(loaded$ | async)"
    (click)="backEmit()"
  >
    {{ backButtonLabel | cxTranslate }}
  </button>
  <button
    class="eb-checkout-buttons__continue-button"
    data-cy="checkout-continue-button"
    [disabled]="disabled || !(loaded$ | async)"
    (click)="nextEmit()"
  >
    {{ nextButtonLabel | cxTranslate }}
    <eb-spinner
      *ngIf="disabled || !(loaded$ | async)"
      [size]="2"
      class="eb-checkout-buttons__spinner"
    ></eb-spinner>
  </button>
</div>
